var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observable, action, makeObservable } from "mobx";
//  import {instances} from '@/middleware/RequestAxios/RequestAxiosMessagePipe'
import differenceInMilliseconds from "date-fns/differenceInMilliseconds";
var GrayLogTypes;
(function (GrayLogTypes) {
    GrayLogTypes["ERROR"] = "ERROR";
})(GrayLogTypes || (GrayLogTypes = {}));
var ErrorSender = /** @class */ (function () {
    function ErrorSender() {
        var _this = this;
        this.PERIODIC_LIMIT = 1;
        this.TOTAL_LIMIT = 50;
        this.TIME_PERIOD = 1000;
        this.sendErrorAPI = function (_a) {
            var message = _a.message, context = _a.context, type = _a.type;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/];
                });
            });
        };
        this.send = function (_a) {
            var message = _a.message, context = _a.context, _b = _a.type, type = _b === void 0 ? GrayLogTypes.ERROR : _b;
            return __awaiter(_this, void 0, void 0, function () {
                var timeDiff, err_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!(this.totalAmount < this.TOTAL_LIMIT)) return [3 /*break*/, 4];
                            if (!this.lastSentErrorTime) {
                                this.lastSentErrorTime = new Date();
                            }
                            timeDiff = differenceInMilliseconds(new Date(), this.lastSentErrorTime);
                            if (timeDiff <= this.TIME_PERIOD &&
                                this.amountDuringTheLimit >= this.PERIODIC_LIMIT) {
                                return [2 /*return*/, false];
                            }
                            if (timeDiff > this.TIME_PERIOD &&
                                this.amountDuringTheLimit >= this.PERIODIC_LIMIT) {
                                this.amountDuringTheLimit = 0;
                                this.lastSentErrorTime = new Date();
                            }
                            this.totalAmount++;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            this.amountDuringTheLimit++;
                            return [4 /*yield*/, this.sendErrorAPI({ message: message, context: context, type: type })];
                        case 2:
                            _c.sent();
                            return [2 /*return*/, true];
                        case 3:
                            err_1 = _c.sent();
                            return [2 /*return*/, false];
                        case 4: return [2 /*return*/, true];
                    }
                });
            });
        };
        this.wait = this.TIME_PERIOD;
        this.amountDuringTheLimit = 0;
        this.totalAmount = 0;
        this.lastSentErrorTime = undefined;
        makeObservable(this, {
            wait: observable,
            amountDuringTheLimit: observable,
            totalAmount: observable,
            lastSentErrorTime: observable,
            send: action,
        });
    }
    return ErrorSender;
}());
export default new ErrorSender();
//# sourceMappingURL=data:application/json;base64,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